import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../environments/environment';

@Injectable()
export class LabelcardMgmtService {

constructor(private _http: HttpClient) { }
//baseUrl: String = 'http://localhost:10325/';
getAllCategories(): any {
    return this._http.get(environment.APIEndpoint+'api/LabelCategories/GetAllCategories')
     .map((res) => res);
  }

  getLanguageList(): any {
    return this._http.get(environment.APIEndpoint+'api/Language/GetLanguageList')
      .map((res) => res)
      .catch(this._errorHandler);
  }
  _errorHandler(error: Response) {
    return Observable.throw(error || 'Server Error');
  }
 
  getAllLabels(): any {
    return this._http.get(environment.APIEndpoint+'api/ApplicationField/GetAllLabel')
      .map((res) => res)
      .catch(this._errorHandler);
  }

  getAllMappedLabels(languageId:any): any {
    return this._http.get(environment.APIEndpoint+'api/ApplicationFieldLanguageMapping/GetAllLangugaeLabelMapping?languageId='+ languageId)
      .map((res) => res)
      .catch(this._errorHandler);
  }

  getAllCategoriesWiseMappedLabels(catid): any {
    
    return this._http.get(environment.APIEndpoint+'api/ApplicationFieldLanguageMapping/GetCategoryWiseLanguageLabelMapping?catid=' + catid)
      .map((res) => res)
      .catch(this._errorHandler);
  }

  saveMappedLabels(mappedlabels: any ) {
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
      return this._http.post(environment.APIEndpoint+'api/ApplicationFieldLanguageMapping/AddMappedLabel', mappedlabels, httpOptions)
      .map((res: Response) => res);
  }


}
